import React from 'react'
import { DidomiSDK } from '@didomi/react'
import CMPService from './CMPService'
import { withEmptyFallbackErrorBoundary } from '../error/EmptyFallbackErrorBoundary'
import { registerConsent } from '../../store/cmp/cmp.actions'
import { useAction } from '../utils/react-redux'

// webpack:BrowserOnly
export default withEmptyFallbackErrorBoundary(function CMPPlaceholder() {
  const execRegisterConsent = useAction(registerConsent)

  return (
    <DidomiSDK
      iabVersion={2}
      apiKey={CMPService.constructor.apiKey}
      noticeId={CMPService.constructor.noticeId}
      onReady={didomiSDK => {
        CMPService.setSDK(didomiSDK)
      }}
      onConsentChanged={() => execRegisterConsent(CMPService.getConsents())}
    />
  )
})
